/**
 * Wallet balance chip rendered in the AppShell top nav and (later) on
 * HomePage. Reads from `useWalletBalance()`; falls back to "—" on error
 * so the nav never crashes if the wallet API is down.
 */

import * as React from 'react';
import { Link } from 'wouter';

import { AnimatedNumber } from '@workspace/ui';
import { useT } from '../providers/LangProvider';
import { useWalletBalance } from '../hooks/useWallet';

export function WalletPill() {
  const t = useT();
  const { data, loading } = useWalletBalance();

  const balanceInRiyal = data ? data.balance / 100 : 0;

  return (
    <Link
      href="/wallet"
      className="flex items-center gap-2 rounded-xl border border-neutral-200 bg-white px-3 py-1.5 text-sm text-neutral-700 hover:border-purple-400 hover:bg-purple-50 focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2"
      aria-label={t.wallet}
    >
      <span aria-hidden="true">💳</span>
      <span className="font-semibold text-neutral-900" aria-live="polite" aria-busy={loading}>
        {loading ? (
          t.walletLoading
        ) : data ? (
          <AnimatedNumber
            value={balanceInRiyal}
            format={(n) => `${n.toLocaleString('ar-SA')} ر.س`}
          />
        ) : (
          t.walletError
        )}
      </span>
    </Link>
  );
}
